var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRailyLogoFull = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "28 10 110 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.4,9.9v40.1h40.1V9.9H27.4z M52,42.2L38,30.1l0,0h0v-3.3h15.6v-5.7H38v-3.3h15.6h3.3v3.3v5.7V30v0H43 l14,12.2H52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.5,22.9v-2.8h17.2v2.8h-7V41h-3.2V22.9H76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5,40.4l6.9-20.2h5.1l6.8,20.2l-0.4,0.6h-2.7l-1.6-5h-9.4l-1.6,5h-2.7L93.5,40.4z M99.1,33.3h7.6 l-3.5-10.3h-0.7L99.1,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,40.3l7-10.1l-6.6-9.5l0.3-0.7h2.8l5.2,7.7l5.3-7.7h2.8l0.3,0.7l-6.6,9.5l7,10.1L131,41h-2.8l-5.7-8.3 l-5.7,8.3h-2.8L113.8,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,41V20.2h3.2V41H135z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRailyLogoFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/raily_logo_full.fbfc70dbe418fe89567769cd86444421.svg";